var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"multiselect-header"}},[(_vm.selectMode)?_c('div',{key:"multiselect-header",staticClass:"multiselect-header"},[_c('div',{staticClass:"button primary",on:{"click":function($event){$event.preventDefault();return _vm.markSelectedSeenOrUnseen.apply(null, arguments)}}},[_c('span',{attrs:{"id":"action-label"}},[_vm._v(_vm._s(_vm.areAllSelectedRead
						? _vm.n(
							'mail',
							'Mark {number} unread',
							'Mark {number} unread',
							_vm.selection.length,
							{
								number: _vm.selection.length,
							}
						)
						: _vm.n(
							'mail',
							'Mark {number} read',
							'Mark {number} read',
							_vm.selection.length,
							{
								number: _vm.selection.length,
							}
						)))])]),_vm._v(" "),_c('Actions',{staticClass:"app-content-list-item-menu",attrs:{"menu-align":"right"}},[(_vm.isAtLeastOneSelectedUnimportant)?_c('ActionButton',{attrs:{"close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.markSelectionImportant.apply(null, arguments)}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('ImportantIcon',{attrs:{"size":20}})]},proxy:true}],null,false,4006335173)},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
							'mail',
							'Mark {number} as important',
							'Mark {number} as important',
							_vm.selection.length,
							{
								number: _vm.selection.length,
							}
						))+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.isAtLeastOneSelectedImportant)?_c('ActionButton',{attrs:{"close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.markSelectionUnimportant.apply(null, arguments)}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('ImportantIcon',{attrs:{"size":20}})]},proxy:true}],null,false,4006335173)},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
							'mail',
							'Mark {number} as unimportant',
							'Mark {number} as unimportant',
							_vm.selection.length,
							{
								number: _vm.selection.length,
							}
						))+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('ActionButton',{attrs:{"close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.favoriteOrUnfavoriteAll.apply(null, arguments)}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconFavorite',{attrs:{"size":20}})]},proxy:true}],null,false,747028727)},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.areAllSelectedFavorite
							? _vm.n(
								'mail',
								'Unfavorite {number}',
								'Unfavorite {number}',
								_vm.selection.length,
								{
									number: _vm.selection.length,
								}
							)
							: _vm.n(
								'mail',
								'Favorite {number}',
								'Favorite {number}',
								_vm.selection.length,
								{
									number: _vm.selection.length,
								}
							))+"\n\t\t\t\t")]),_vm._v(" "),(_vm.isAtLeastOneSelectedNotJunk)?_c('ActionButton',{attrs:{"close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.markSelectionJunk.apply(null, arguments)}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('AlertOctagonIcon',{attrs:{"size":20}})]},proxy:true}],null,false,4042396370)},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
							'mail',
							'Mark {number} as spam',
							'Mark {number} as spam',
							_vm.selection.length,
							{
								number: _vm.selection.length,
							}
						))+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.isAtLeastOneSelectedJunk)?_c('ActionButton',{attrs:{"close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.markSelectionNotJunk.apply(null, arguments)}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('AlertOctagonIcon',{attrs:{"size":20}})]},proxy:true}],null,false,4042396370)},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
							'mail',
							'Mark {number} as not spam',
							'Mark {number} as not spam',
							_vm.selection.length,
							{
								number: _vm.selection.length,
							}
						))+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('ActionButton',{attrs:{"close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.unselectAll.apply(null, arguments)}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconSelect',{attrs:{"size":20}})]},proxy:true}],null,false,3052863531)},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
						'mail',
						'Unselect {number}',
						'Unselect {number}',
						_vm.selection.length,
						{
							number: _vm.selection.length,
						}
					))+"\n\t\t\t\t")]),_vm._v(" "),_c('ActionButton',{attrs:{"close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.onOpenTagModal.apply(null, arguments)}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('TagIcon',{attrs:{"size":20}})]},proxy:true}],null,false,3295128625)},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
						'mail',
						'Edit tags for {number}',
						'Edit tags for {number}',
						_vm.selection.length,
						{
							number: _vm.selection.length,
						}
					))+"\n\t\t\t\t")]),_vm._v(" "),(!_vm.account.isUnified)?_c('ActionButton',{attrs:{"close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.onOpenMoveModal.apply(null, arguments)}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('OpenInNewIcon',{attrs:{"size":20}})]},proxy:true}],null,false,1266168172)},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
						'mail',
						'Move {number} thread',
						'Move {number} threads',
						_vm.selection.length,
						{
							number: _vm.selection.length,
						}
					))+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('ActionButton',{attrs:{"close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.forwardSelectedAsAttachment.apply(null, arguments)}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('ShareIcon',{attrs:{"title":_vm.t('mail', 'Forward'),"size":20}})]},proxy:true}],null,false,3681882419)},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
						'mail',
						'Forward {number} as attachment',
						'Forward {number} as attachment',
						_vm.selection.length,
						{
							number: _vm.selection.length,
						}
					))+"\n\t\t\t\t")]),_vm._v(" "),_c('ActionButton',{attrs:{"close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.deleteAllSelected.apply(null, arguments)}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconDelete',{attrs:{"size":20}})]},proxy:true}],null,false,881161434)},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
							'mail',
							'Delete {number} thread',
							'Delete {number} threads',
							_vm.selection.length,
							{
								number:
									_vm.selection.length,
							}
						))+"\n\t\t\t\t")])],1),_vm._v(" "),(_vm.showMoveModal)?_c('MoveModal',{attrs:{"account":_vm.account,"envelopes":_vm.selectedEnvelopes,"move-thread":true},on:{"close":_vm.onCloseMoveModal}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('transition-group',{attrs:{"name":"list"}},[_vm._l((_vm.sortedEnvelops),function(env,index){return _c('Envelope',{key:env.databaseId,attrs:{"data":env,"mailbox":_vm.mailbox,"selected":_vm.selection.includes(env.databaseId),"select-mode":_vm.selectMode,"has-multiple-accounts":_vm.hasMultipleAccounts,"selected-envelopes":_vm.selectedEnvelopes},on:{"delete":function($event){return _vm.$emit('delete', env.databaseId)},"update:selected":function($event){return _vm.onEnvelopeSelectToggle(env, index, $event)},"select-multiple":function($event){return _vm.onEnvelopeSelectMultiple(env, index)}}})}),_vm._v(" "),(_vm.loadMoreButton && !_vm.loadingMore)?_c('div',{key:'list-collapse-' + _vm.searchQuery,staticClass:"load-more",on:{"click":function($event){return _vm.$emit('load-more')}}},[_c('AddIcon',{attrs:{"size":20}}),_vm._v("\n\t\t\t"+_vm._s(_vm.t('mail', 'Load more'))+"\n\t\t")],1):_vm._e(),_vm._v(" "),_c('div',{key:"loadingMore",class:{'icon-loading-small': _vm.loadingMore},attrs:{"id":"load-more-mail-messages"}})],2),_vm._v(" "),(_vm.showTagModal)?_c('TagModal',{attrs:{"account":_vm.account,"envelopes":_vm.selectedEnvelopes},on:{"close":_vm.onCloseTagModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }